import React, { useCallback, useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import useRoutesHelper from "../../../hooks/useRoutesHelper";

import {
  fetchAllFleetDocs,
  fetchShowAllDocTypes,
} from "../../../redux/api/fleet.api";

import {
  fleetAllDocumentsTableHeader,
  getFleetAllDocumentsTableData,
} from "./components/tableConfigs/fleetAllDocumentsTableConfig";

import TableWidget from "../../../components/tables/TableWidget";
import Text from "../../../styleguide/Text";
import {
  clearFleetAllDocuments,
  clearFleetTypeData,
} from "../../../redux/reducer/fleet.reducer";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

import FleetAllDocumentsActionButton from "./components/TableActionButtonsComponents/FleetAllDocumentsActionButton";

function FleetAllDocumets({ withCarId }: { withCarId?: boolean }) {
  const dispatch = useAppDispatch();

  const { routeMainParam, routeParams } = useRoutesHelper();

  const { carId } = routeMainParam as { carId: string };
  const { nrauto } = routeParams as { nrauto: string };
  const { valability } = routeParams as { valability: string };

  const {
    fleet: {
      fleetAllDocuments: {
        data: { data: fleetAllDocumentsData, total },
        isLoading: isLoading,
      },
      fleetTypeDataAllDocs: {
        data: fleetTypeDataAllDocs,
        isLoading: fleetTypesLoading,
      },
    },
  } = useAppSelector((state) => ({
    fleet: state.fleet,
  }));

  useEffect(() => {
    dispatch(fetchShowAllDocTypes());
    return () => {
      dispatch(clearFleetTypeData());
      dispatch(clearFleetAllDocuments());
    };
  }, [dispatch]);

  const handleTableActions = useCallback(
    (action: TableActions) => {
      if (
        valability &&
        action.tablePagination.page &&
        action.tablePagination.rowsPerPage &&
        action.tableSearch
      ) {
        dispatch(
          fetchAllFleetDocs({
            idAuto: carId,
            valability: valability,
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            documentType: action.tableSearch.documentType,
            nr_auto: action.tableSearch.nr_auto,
          }),
        );
      }
    },
    [dispatch, carId, valability],
  );

  const fleetAllDocumentsTableHeaderNew = useMemo(
    () =>
      fleetAllDocumentsTableHeader.map((item) => {
        if (!fleetTypesLoading && item.value === "documentType") {
          const fleetTypesDropdown = fleetTypeDataAllDocs?.map(
            ({ label, id }) => ({
              label,
              value: id,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...fleetTypesDropdown],
            ...item,
          };
        }
        return item;
      }),
    [fleetTypeDataAllDocs, fleetTypesLoading],
  );

  return (
    <TableWidget
      CustomHeaderComponent={() => (
        <div className="flex flex-col">
          <Text
            variant="h3"
            component="h3"
            className="mb-4 font-semibold text-slate-900"
            gutterBottom>
            {carId ? `Documente masina ${nrauto}` : "Documente masini"}
          </Text>
        </div>
      )}
      tableHeaderData={fleetAllDocumentsTableHeaderNew}
      tableItemsData={getFleetAllDocumentsTableData(fleetAllDocumentsData)}
      handleTableActions={handleTableActions}
      borderedRow
      tableLoading={isLoading || fleetTypesLoading}
      ActionButtonsComponent={
        withCarId ? undefined : FleetAllDocumentsActionButton
      }
      totalItems={total}
    />
  );
}

export default FleetAllDocumets;
